// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SuperCheckbox_checkbox__1Q2IN","spanClassName":"SuperCheckbox_spanClassName__2LfVy"};